<template>
  <div class="container-fluid">
    <!-- Page Heading -->
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <h1 class="h3 mb-0 text-gray-800">Agents Status</h1>
    </div>

    <!-- Content Row -->
    <div class="row col-12 mx-auto col-status p-0">

      <div class="mb-4 w-25">
        <div class="card shadow h-100 py-2 ml-2 bg-success">
          <div class="card-header py-1">
            <div class="row no-gutters">
                <div class="col-md-8 font-weight-regular text-white text-uppercase">
                  Online
                </div>
                <div class="col-md-4 h4 font-weight-bold text-white"><p class="mb-0 float-right">{{ onlineAgents.length }}</p></div>
            </div>
          </div>
          <div class="card-body card-body-status pt-0">
            <div class="agents-status" v-if="system != null">
              <!-- Agent Online -->
              <div
                class="mt-4 mr-2"
                v-for="agent in onlineAgents"
                :key="agent.name"
              >
              <div>
                <agent-status :agent="agent" />
              </div>
              </div>
            </div>
            <div class="row" v-else>
              <Loader text="Loading..." />
            </div>
          </div>
        </div>
      </div>
      
      <div class="mb-4 w-25">
        <div class="card shadow h-100 py-2 ml-2 bg-primary">
          <div class="card-header py-1">
            <div class="row no-gutters">
                <div class="col-md-8 font-weight-regular text-white text-uppercase">
                  Incall
                </div>
                <div class="col-md-4 h4 font-weight-bold text-white"><p class="mb-0 float-right">{{ inCallAgents.length }}</p></div>
            </div>
          </div>
          <div class="card-body card-body-status pt-0">
            <div class="agents-status" v-if="system != null">
              <!-- Agent InCall -->
              <div
                class="mt-4 mr-2"
                v-for="agent in inCallAgents"
                :key="agent.name"
              >
              <div>
                <agent-status :agent="agent" />
              </div>
              </div>
            </div>
            <div class="row" v-else>
              <Loader text="Loading..."/>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-4 w-25">
        <div class="card shadow h-100 py-2 ml-2 bg-danger">
          <div class="card-header py-1">
            <div class="row no-gutters">
                <div class="col-md-8 font-weight-regular text-white text-uppercase">
                  Disabled
                </div>
                <div class="col-md-4 h4 font-weight-bold text-white"><p class="mb-0 float-right">{{ disabledAgents.length }}</p></div>
            </div>
          </div>
          <div class="card-body card-body-status pt-0">
            <div class="agents-status" v-if="system != null">
              <!-- Agent Disabled -->
              <div
                class="mt-4 mr-2"
                v-for="agent in disabledAgents"
                :key="agent.name"
              >
              <div>
                <agent-status :agent="agent" />
              </div>
              </div>
            </div>
            <div class="row" v-else>
              <Loader text="Loading..." />
            </div>
          </div>
        </div>
      </div>

      <div class="mb-4 w-25">
        <div class="card shadow h-100 py-2 ml-2 bg-secondary">
          <div class="card-header py-1">
            <div class="row no-gutters">
                <div class="col-md-8 font-weight-regular text-white text-uppercase">
                  Offline
                </div>
                <div class="col-md-4 h4 font-weight-bold text-white"><p class="mb-0 float-right">{{ offlineAgents.length }}</p></div>
            </div>
          </div>
          <div class="card-body card-body-status pt-0">
            <div class="agents-status" v-if="system != null">
              <!-- Agent Offline -->
              <div
                class="mt-4 mr-2"
                v-for="agent in offlineAgents"
                :key="agent.name"
              >
              <div>
                <agent-status :agent="agent" />
              </div>
              </div>
            </div>
            <div class="row" v-else>
              <Loader text="Loading..." />
            </div>
          </div>
        </div>
      </div>
      
    </div>

  </div>
  <!-- /.container-fluid -->
</template>

<script>
import AgentStatus from "@/components/AgentStatus";
import Loader from "@/components/Loader";
import { mapGetters } from "vuex";

export default {
  name: "Status",
  data: () => ({}),
  computed: {
    ...mapGetters(["system"]),
    onlineAgents() {
      return this.filterAgents('online');
    },
    inCallAgents() {
      return this.filterAgents('busy');
    },
    disabledAgents() {
      return this.filterAgents('disabled');
    },
    offlineAgents() {
      return this.filterAgents('offline');
    },
  },
  methods: {
    filterAgents(status) {
      if (!this.system || !this.system.agents) {
        return []
      }

      return this.system.agents.filter(function(value) {
        return value.status == status;
      })
    }
  },
  components: {
    "agent-status": AgentStatus,
    Loader,
  },
};
</script>